import React, {
    useLayoutEffect,
    useState,
} from "react";
import Box from "@mui/material/Box";
import {
    Avatar,
    Button,
    Paper,
    Stack,
    Tab,
    Tabs,
    TextField,
    Typography,
    useMediaQuery,
} from "@mui/material";

import { useAuthStore } from "../../../../store/auth.store";

export function AccountTab() {
    const { logout, fetchMe, user } = useAuthStore();
    const isMobile = useMediaQuery("(max-width:700px)");

    const [form, setForm] = useState({
        lastName: user?.first_name || "",
        firstName: user?.last_name || "",
        middleName: user?.middle_name || "",
        phone: user?.phone || "",
        email: user?.email || "",
    });

    useLayoutEffect(() => {
        fetchMe();
    }, []);

    useLayoutEffect(() => {
        setForm({
            lastName: user?.first_name || "",
            firstName: user?.last_name || "",
            middleName: user?.middle_name || "",
            phone: user?.phone || "",
            email: user?.email || "",
        });
    }, [user]);

    const handleChange = (field: string) => (e: any) => {
        setForm((prev) => ({ ...prev, [field]: e.target.value }));
    };

    const handleSubmit = (e: any) => {
        e.preventDefault();

        console.log("form:", form);
    };

    return (
        <div>
            <Box
                component="form"
                onSubmit={handleSubmit}
                noValidate
                sx={{ maxWidth: 560 }}
            >
                {/* <Stack direction="row" spacing={2} alignItems="center">
                    <Avatar sx={{ width: 96, height: 96 }} />

                    <Stack spacing={1}>
                        <Box
                            sx={{
                                display: "flex",
                                gap: "8px",
                                flexDirection: isMobile ? "column" : "row",
                            }}
                        >
                            <Button
                                variant="contained"
                                component="label"
                                sx={{
                                    flex: 1,
                                }}
                            >
                                Загрузить фото
                                <input
                                    type="file"
                                    hidden
                                    accept="image/jpeg,image/png,image/gif"
                                />
                            </Button>

                            <Button variant="outlined">Удалить</Button>
                        </Box>

                        <Typography variant="body2" color="text.secondary">
                            Максимальный размер файла — 25 МБ, доступные типы
                            изображений — JPG, GIF, PNG.
                        </Typography>
                    </Stack>
                </Stack> */}
                <Stack
                    spacing={3}
                    sx={{
                        marginTop: "28px",
                    }}
                >
                    <TextField
                        label="Фамилия"
                        placeholder="Введите фамилию"
                        value={user?.last_name}
                        onChange={handleChange("lastName")}
                        fullWidth
                        slotProps={{
                            htmlInput: { maxLength: 60 },
                        }}
                        InputLabelProps={{ shrink: true }}
                        disabled
                    />

                    <TextField
                        label="Имя"
                        placeholder="Введите имя"
                        value={user?.first_name}
                        onChange={handleChange("firstName")}
                        fullWidth
                        slotProps={{
                            htmlInput: { maxLength: 60 },
                        }}
                        disabled
                    />

                    <TextField
                        label="Отчество"
                        placeholder="Введите отчество"
                        value={form.middleName}
                        onChange={handleChange("middleName")}
                        fullWidth
                        slotProps={{
                            htmlInput: { maxLength: 60 },
                        }}
                        disabled
                    />

                    <TextField
                        label="Телефон"
                        placeholder="+7 (___) ___-__-__"
                        value={form.phone}
                        onChange={handleChange("phone")}
                        fullWidth
                        disabled
                    />

                    <TextField
                        label="Адрес электронной почты"
                        value={form.email}
                        onChange={handleChange("email")}
                        fullWidth
                        disabled
                    />

                    <Stack
                        direction="row"
                        justifyContent="flex-end"
                        gap={"20px"}
                    >
                        <Button type="submit" variant="contained" disabled>
                            Сохранить
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            color="error"
                            onClick={() => logout()}
                        >
                            Выйти
                        </Button>
                    </Stack>
                </Stack>
            </Box>
        </div>
    );
}
